/* eslint-disable import/prefer-default-export */
import requests from '@webclient/lib/agent/requests';
import axiosApiInstance from '@webclient/lib/agent/services/api/axiosInstance';
import axiosAwsInstance from '@webclient/lib/agent/services/aws/axiosInstance';

import {
  CommandDefinition,
  CommandMinType,
  CommandType,
  CreateOneCommandParamsType,
  UpdateOneCommandParamsType,
} from '@webclient/shared-types/commands';

type CommandSubscriptionType = {
  status: 'ok';
  runToken: string;
  expiresInSeconds: number;
};

type CommandRunType = {
  status: 'ok';
  runToken: string;
  threadId: string;
};

export const commands = {
  subscribe: (commandId: number | string) =>
    requests(axiosApiInstance).get<CommandSubscriptionType>(
      `/v1/actions/command/${commandId}/subscribe`,
    ),
  trigger: (commandId: number | string, body: unknown, ownerId?: string) => {
    return commands.triggerEndpoint(
      `/v1/actions/command/${commandId}/trigger?mode=debug&async=true`,
      body,
      ownerId,
    );
  },
  triggerEndpoint: (endpoint: string, body: unknown, ownerId?: string) => {
    const config = ownerId
      ? { headers: { 'Knowz-Creation-Owner': ownerId } }
      : {};

    return requests(axiosApiInstance).post<CommandRunType>(
      endpoint,
      body,
      config,
    );
  },
  createOneCommand: (body: CreateOneCommandParamsType, ownerId?: string) => {
    const config = ownerId
      ? { headers: { 'Knowz-Creation-Owner': ownerId } }
      : {};

    return requests(axiosApiInstance).post<CommandType>(
      '/v1/entities/commands',
      body,
      config,
    );
  },
  updateOneCommand: (
    { id, ...body }: UpdateOneCommandParamsType,
    ownerId?: string,
  ) => {
    const config = ownerId
      ? { headers: { 'Knowz-Creation-Owner': ownerId } }
      : {};

    return requests(axiosApiInstance).patch<CommandType>(
      `/v1/entities/commands/${id}`,
      body,
      config,
    );
  },
  deleteOneCommand: (commandId: number | string, ownerId?: string) => {
    const config = ownerId
      ? { headers: { 'Knowz-Creation-Owner': ownerId } }
      : {};

    return requests(axiosApiInstance).delete(
      `/v1/entities/commands/${commandId}`,
      config,
    );
  },
  getAllCommands: ({
    parentCommandId,
    limit = 12,
    order = 'desc',
    page = 1,
  }: {
    parentCommandId?: number | string;
    limit?: number;
    order?: 'asc' | 'desc';
    page?: number;
  } = {}) => {
    return axiosApiInstance.get<CommandMinType[]>('/v1/entities/commands', {
      params: {
        parent: parentCommandId,
        limit,
        order,
        page,
      },
    });
  },
  getCommand: (commandId: number | string) =>
    requests(axiosApiInstance).get<CommandType>(
      `/v1/entities/commands/${commandId}`,
    ),
  getCommandDefinition: (signedUrl: string) =>
    requests(axiosAwsInstance).get<CommandDefinition>(signedUrl),
};
